import { FadeIn } from "@/components/FadeIn";

const PROGRAM_IMAGE =
  "https://customer-assets.emergentagent.com/job_pond-education-hub/artifacts/0pg03m8c_6d73d77a-acfa-410d-b98a-1471b8934ff0.png";

const PROGRAMS = [
  {
    index: "A",
    title: "Foundations of pond aquaculture",
    note: "Designed for complete beginners",
    body: "A plain-language introduction to how pond aquaculture actually works in Alberta: what's possible, what's legal, what it costs, and what it will ask of you.",
    featured: true,
    id: "foundations",
  },
  {
    index: "B",
    title: "Water & pond ecology",
    note: "The science beneath the surface",
    body: "Water chemistry, oxygen dynamics, plants, and the biological systems that support healthy fish populations.",
    id: "ecology",
  },
  {
    index: "C",
    title: "Seasonal operations",
    note: "Alberta's four very real seasons",
    body: (
      <>
        Feeding, monitoring, winterkill prevention, and the working rhythm of a pond
        <br className="hidden lg:block" /> across the year.
      </>
    ),
    id: "operations",
  },
  {
    index: "D",
    title: "Regulation, compliance & risk",
    note: "The paperwork that protects you",
    body: "Licences, water rights, permitted species, and biosecurity are covered with clear guidance on Alberta regulations and requirements.",
    id: "compliance",
  },
  {
    index: "E",
    title: "One-on-one guidance",
    note: "Remote or on-site, across Alberta",
    body: "Property-specific consulting with support for planning, implementation, and ongoing pond management.",
    id: "guidance",
  },
];

export const Programs = () => {
  return (
    <section id="programs" data-testid="programs-section" className="bg-background">
      {/* Sticky split-screen: image pinned left while curriculum scrolls right */}
      <div className="grid grid-cols-1 lg:grid-cols-12">
        <div className="lg:col-span-6 lg:pt-20 lg:pb-0">
          <div className="lg:sticky lg:top-24">
            <FadeIn>
              <div className="relative img-grade h-[37vh] lg:h-[720px]" data-testid="programs-image">
                <img
                  src={PROGRAM_IMAGE}
                  alt="Aerial view of a prairie dugout pond beside a country road on Alberta farmland at golden hour"
                  className="editorial-img"
                  loading="lazy"
                />
              </div>
            </FadeIn>
          </div>
        </div>

        <div className="lg:col-span-6 px-5 sm:px-8 lg:pl-16 lg:pr-[max(2rem,calc((100vw-1280px)/2+2rem))] pt-[50px] pb-[50px] lg:pt-20 lg:pb-10">
          <FadeIn>
            <h2 className="font-serif-heading font-medium text-4xl sm:text-5xl lg:text-[clamp(2.25rem,2.9vw+0.5rem,3.4rem)] leading-[1.05] tracking-[-0.015em] text-foreground">
              Learning path
            </h2>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-foreground/65 max-w-[48ch]">
              Every program is designed to provide practical knowledge and help
              you make informed decisions. Learn at whatever depth your project
              demands.
            </p>

            <div className="mt-[43px] lg:mt-12">
              {PROGRAMS.map((p) => (
                <div
                  key={p.id}
                  data-testid={`programs-item-${p.id}`}
                  className={`hairline py-6 ${p.featured ? "bg-[color:var(--apn-sage-2)]/60 -mx-4 px-4" : ""}`}
                >
                  <div>
                    <h3 className="font-serif-heading text-lg sm:text-xl font-medium text-foreground">
                      {p.title}
                      {p.featured && (
                        <span className="block mt-2 ml-0 lg:inline lg:mt-0 lg:ml-3 font-mono-meta text-[9px] align-middle text-[color:var(--apn-forest)]">
                          ← start here
                        </span>
                      )}
                    </h3>
                    <p className="mt-2.5 text-sm leading-relaxed text-foreground/65">{p.body}</p>
                  </div>
                </div>
              ))}
              <div className="hairline" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};
